import { render, staticRenderFns } from "./InpatientInquiry.vue?vue&type=template&id=09eede90&scoped=true"
import script from "./InpatientInquiry.vue?vue&type=script&lang=js"
export * from "./InpatientInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eede90",
  null
  
)

export default component.exports